import React from "react";
import Icon from "components/AppIcon";

const SearchBar = ({ value, onChange, resultCount, totalCount }) => (
  <div className="flex flex-col sm:flex-row sm:items-center gap-3">
    <div className="relative flex-1 max-w-sm">
      <Icon name="Search" size={16} color="var(--color-muted-foreground)" className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder="Search players by name or position..."
        className="w-full pl-9 pr-4 py-2 rounded-lg border text-sm font-caption focus:outline-none transition-athletic"
        style={{
          backgroundColor: "var(--color-input)",
          borderColor: "var(--color-border)",
          color: "var(--color-foreground)",
        }}
        onFocus={(e) => { e.target.style.borderColor = "var(--color-primary)"; e.target.style.boxShadow = "0 0 0 3px rgba(232,93,4,0.15)"; }}
        onBlur={(e) => { e.target.style.borderColor = "var(--color-border)"; e.target.style.boxShadow = "none"; }}
        aria-label="Search players"
      />
      {value && (
        <button className="absolute right-3 top-1/2 -translate-y-1/2" onClick={() => onChange("")} aria-label="Clear search">
          <Icon name="X" size={14} color="var(--color-muted-foreground)" />
        </button>
      )}
    </div>
    {value && (
      <p className="font-caption text-sm" style={{ color: "var(--color-muted-foreground)" }}>
        Showing <strong style={{ color: "var(--color-foreground)" }}>{resultCount}</strong> of {totalCount} players
      </p>
    )}
  </div>
);

export default SearchBar;